module.exports = __webpack_public_path__ + "img/index_logo.d56dcfe4.png";